import apiUser from "../../api";
import {
  accountFilterFields,
  activityFilterFields,
  companyFilterField,
  designationFilterField,
  settledRows,
  userFullName,
} from "../../features/user.filter";

// Advanced filter for the employees list (see ../../features/user.filter.js).
export const filterFields = [
  companyFilterField,
  designationFilterField,
  { key: "manager_fids", label: "Managers", type: "select", group: "Organization", optionsKey: "admins", optionLabelFormatter: userFullName },
  ...accountFilterFields,
  ...activityFilterFields,
];

// Dropdown data for the filter, fetched once when the drawer first opens.
export const loadFilterDependencies = async () => {
  const [companiesRes, designationsRes, adminsRes] = await Promise.allSettled([
    apiUser.getCompanies(),
    apiUser.getDesignations(),
    apiUser.getAllClients({ role: "ADMIN" }),
  ]);

  return {
    companies: settledRows(companiesRes),
    designations: settledRows(designationsRes),
    admins: settledRows(adminsRes),
  };
};
